import { mapGetters, mapActions } from "vuex";
import TableauDestinataire from '../TableauDestinataires/TableauDestinataires.vue'
import FileDrop from '../FileDrop/FileDrop.vue'
import Vue from 'vue'
import SearchDestinataire from '../../components/SearchDestinataire/searchDestinataire';

export default {
    name: "DetailCommande",
    components: {
        TableauDestinataire,
        FileDrop,
    },
    props: ["commandeId", "expanded"],
    computed: {
        ...mapGetters(["auth"]),
        composantes() {
            return this.commande.categorie.composantes.filter((comp) => {
                return comp.sous_categorie_id === this.commande.sous_categorie_id || !this.commande.sous_categorie_id
            })
        },
        isAdmin() {
            if(this.auth && this.auth.user && this.auth.user.roles &&
                this.auth.user.roles.find((role) => role.name === "admin")) {
                return true
            }
            return false
        },
        allDocs() {
            return this.commande.commande_documents.concat(this.commande.commande_fichiers)
        },
        nbElectronique() {
            return this.commande.commande_destinataires.filter(
                    dest => dest.electronique === 1 && dest.avancement === 0
                ).length;
        },
        nbElectroniqueTotal() {
            return this.commande.commande_destinataires.filter(
                    dest => dest.electronique === 1
                ).length;
        },
        nbEnvoiEmail() {
            return this.commande.commande_destinataires.filter(
                    dest => dest.envoi_email === 1 && dest.avancement === 0
                ).length;
        },
        nbEnvoiEmailTotal() {
            return this.commande.commande_destinataires.filter(
                    dest => dest.envoi_email === 1
                ).length;
        },
        nbElectroniqueEnvoye() {
            return this.commande.commande_destinataires.filter(
                    dest => dest.electronique === 1 && dest.avancement > 0
                ).length;
        },
        nbCourrierEnvoye() {
            return this.commande.commande_destinataires.filter(
                dest => dest.electronique === 0 && dest.avancement > 0
            ).length;
        },
        nbCourrier() {
            return this.commande.commande_destinataires.filter(dest => dest.electronique === 0).length;
        },
        isSousCategorieSansDestinataire() {
            return this.composantes.find(f => f.libelle === 'Destinataires') == undefined
        },
    },
    data() {
        return {
            commande: {},
            dragging: false,
            envoiEnCours: false,
            envoiEmailEnCours: false,
            rafraichissementEnCours: false,
            saveTimeout: 0,
            timeoutCommande: 0,
            commandeLoading: true,
            files: [],
            fileObjectTab: [],
            uploadTimeout: 0,
        };
    },
    methods: {
        ...mapActions([
            "sendCommandeLetreco", "getDepositProof", "checkCommande", "updateDestinataires", "loadCommande",
            "sendCommande", "updateCommande", "exportDestinataires", "uploadFiles", "downloadAll", "sendEmails", 
            "supprimerCommande", "parsePDF", "exportDestinatairesPrepaFacile", "getDepositProofPrepaFacile",
            "exporFicheTravailSyndic"
        ]),
        confirmerSupprimerCommande(commande) {
            this.rafraichissementEnCours = true
            this.supprimerCommande({commande, callerComponent: this}).then((accepted) => {
                if(accepted) {
                    this.$emit("commandeSupprimee", this.commande);
                }
                this.rafraichissementEnCours = false
            })
        },
        saveDestinataires(dest) {
            clearTimeout(this.saveTimeout)
            this.saveTimeout = setTimeout(() => {
                this.updateDestinataires(this.commande).then(response => {
                    this.commande.commande_destinataires = response.data;
                    this.$toasted.show("Destinataires mis à jour.", {
                        icon: {
                            name: 'check-circle',
                        },
                        theme: "outline",
                        position: "bottom-center",
                        duration : 1000
                    });
                });
            }, 1000);
        },
        addFileBtn(event) {
            this.sendFiles(event.target.files)
            event.target.value = ''
        },
        addFileDnD(event) {
            if (event.dataTransfer.files) {
                this.sendFiles(event.dataTransfer.files)
            };
        },
        addPDFDnD(event) {
            if (event.dataTransfer.files) {
                this.sendPDF(event.dataTransfer.files)
            };
        },
        addPDFBtn(event) {
            this.sendPDF(event.target.files)
            event.target.value = ''
        },
        sendPDF(files) {
            this.dragging = false;
            let formData = new FormData();
            [...files].forEach((file,index) => {
                formData.append('pdfs'+index, file);
            });
            this.parsePDF({formData, commande: this.commande}).then(response => {
                this.$emit("commandeMiseAJour", this.commande);
                const destinataires = response.data.filter(d => d.destinataire && d.destinataire.id)
                this.$toasted.show("Le PDF a été analysé. "+destinataires.length+" destinataires ont été mis à jour.", {
                    icon: {
                        name: 'check-circle',
                    },
                    theme: "outline",
                    position: "bottom-center",
                    duration : 5000
                });
            })
            this.fileSelect = 0;
        },
        sendFiles(files) {
            this.dragging = false;
            let formData = new FormData();
            [...files].forEach((file,index) => {
                formData.append('file'+index, file);
            });
            this.uploadFiles(formData).then(response => {
                this.commande.documents = response.data;
                this.updateCommande(this.commande).then(response => {
                    this.commande.commande_destinataires = response.data.commande_destinataires;
                    this.commande.commande_documents = response.data.commande_documents;
                    this.commande.commande_fichiers = response.data.commande_fichiers;
                    this.commande.documents = [];
                    this.initFileDrop();
                    let hasUpdate = false
                    this.files.forEach(composante => {
                        if(composante.title != 'Destinataires') {
                            composante.children.forEach(file => {
                                if(!file.destinataire) {
                                    file.destinataire = []
                                }
                                if(file.destinataire.length === 0) {
                                    SearchDestinataire.searchDestinataire(file.title, this.commande.commande_destinataires).forEach(e => {
                                        file.destinataire.push(e)
                                        file.destinataire_id = e.id
                                        hasUpdate = true
                                    })
                                }
                            })
                        }
                    })
                    // 2eme update si il y a eu des matches
                    if(hasUpdate) {
                        this.updateCommande(this.commande).then(response => {
                            this.$toasted.show("Commande mise à jour.", {
                                icon: {
                                    name: 'check-circle',
                                },
                                theme: "outline",
                                position: "bottom-center",
                                duration : 2000
                            });
                        })
                    } else {
                        this.$toasted.show("Commande mise à jour.", {
                            icon: {
                                name: 'check-circle',
                            },
                            theme: "outline",
                            position: "bottom-center",
                            duration : 2000
                        });
                    }
                });
            })
            this.fileSelect = 0;
        },
        fichiers(composanteId) {
            return this.commande.commande_fichiers.filter(fic => fic.composante_id === composanteId)
        },
        telechargerPreuveDeDepot(reference) {
            this.envoiEnCours = true;
            this.getDepositProof(reference).then(() => this.envoiEnCours = false);
        },
        telechargerPreuveDeDepotPrepaFacile() {
            this.envoiEnCours = true;
            this.getDepositProofPrepaFacile(this.commande).then(() => this.envoiEnCours = false);
        },
        rafraichir(commande) {
            this.rafraichissementEnCours = true;
            this.checkCommande(commande).then(() => {
                this.$emit("commandeMiseAJour", this.commande);
                this.rafraichissementEnCours = false;
            });
        },
        envoyerCommande() {
            this.envoiEnCours = true
            this.commande.etat = 2
            this.sendCommande(this.commande).then(response => {
                this.envoiEnCours = false
                this.commande.commande_destinataires.forEach(dest => {
                    if(dest.electronique != 1 && dest.envoi_email  != 1) {
                        dest.avancement = 5
                    }
                });
                this.$toasted.show("La commande a été mise à jour", {
                    icon: {
                        name: 'check-circle',
                    },
                    theme: "outline",
                    position: "bottom-center",
                    duration : 2000
                });
                this.$emit("commandeExpediee", this.commande);
            }).catch((e) => {
                this.envoiEnCours = false;
            })
        },
        envoyerDocument() {
            this.envoiEnCours = true
            this.sendCommandeLetreco(this.commande.id).then(response => {
                this.commande.ref_suivi_poste = response.data.ref_suivi_poste
                this.envoiEnCours = false
                this.commande.commande_destinataires.forEach(dest => {
                    if(dest.electronique == 1) {
                        dest.avancement = 2
                    }
                });
                this.$toasted.show("Commande expédiée", {
                    icon: {
                        name: 'check-circle',
                    },
                    theme: "outline",
                    position: "bottom-center",
                    duration : 2000
                });
                this.$emit("commandeExpediee", this.commande);
            }).catch((e) => {
                this.envoiEnCours = false;
            })
        },
        envoyerEmails() {
            this.envoiEmailEnCours = true
            this.sendEmails(this.commande).then(() => {
                this.envoiEmailEnCours = false
                this.commande.commande_destinataires.forEach(dest => {
                    if(dest.envoi_email == 1) {
                        dest.avancement = 5
                    }
                });
                this.$toasted.show("Emails expédiés", {
                    icon: {
                        name: 'check-circle',
                    },
                    theme: "outline",
                    position: "bottom-center",
                    duration : 2000
                });
                this.$emit("commandeExpediee", this.commande);
            }).catch((e) => {
                console.log(e)
                this.envoiEmailEnCours = false;
            })
        },
        saveAfterWait() {
            if(this.timeoutCommande) {
                clearTimeout(this.timeoutCommande);
            }
            this.timeoutCommande = setTimeout(() => {  
                this.updateCommande(this.commande).then(response => {
                    this.$toasted.show("Commande mise à jour.", {
                        icon: {
                            name: 'check-circle',
                        },
                        theme: "outline",
                        position: "bottom-center",
                        duration : 2000
                    });
                });
            }, 2000);
        },
        dowloadAll(id) {
          this.downloadAll(this.commande.id).then(response => {
              this.$toasted.show("Fichiers téléchargés", {
                icon: {
                    name: 'check-circle',
                },
                theme: "outline",
                position: "bottom-center",
                duration : 2000
              });
          }).catch((e) => {
            this.$toasted.show("Impossible de télécharger les fichiers", {
              theme: "error",
              position: "bottom-center",
              duration : 2000
            });
          })
        },
        selectDestinataire({file, dest}) {
            if(dest.id) {
                file.destinataire_id = dest.id
            } else {
                file.destinataire_id = null
            }
            this.saveAfterWait()
        },
        initFileDrop() {
            const composantes = this.commande.categorie.composantes.filter((comp) => {
                return comp.sous_categorie_id === this.commande.sous_categorie_id || !this.commande.sous_categorie_id
            });
            this.commande.commande_fichiers.forEach((f) => {
                f.title = f.libelle
                f.type = f.libelle.split('.').pop()
                f.destinataire = []
            });
            composantes.forEach((comp) => {
                comp.title = comp.libelle
                comp.optionsText =  Vue.filter('mapComposante')(this.commande.commande_has_groupe_options, comp.id);
                comp.isWaitingNode = false;
                comp.options = this.commande.commande_has_groupe_options.filter((option) => {
                    return option.composante_id === comp.id
                })
                comp.options.forEach((option) => {
                    option.groupe = {group_options: [option.group_option]}
                });
                comp.children = this.commande.commande_fichiers.filter((f) => {
                    return f.composante_id === comp.id
                });
            });
            this.files.splice(0, this.files.length)
            this.fileObjectTab.splice(0, this.fileObjectTab.length)
            this.files = composantes;
        }
    },
    watch: {
        'commande.commentaire': function(oldComment, newComment) {
            if(oldComment != newComment && newComment != null) {
                this.saveAfterWait();
            }
        },
        fileObjectTab: function(oldFOT, newFOT) {
            clearTimeout(this.uploadTimeout)
            if(newFOT.length > 0) {
                this.uploadTimeout = setTimeout(() => {
                    console.log("updated files", newFOT)
                    this.sendFiles(newFOT);
                }, 1000);
            }
        },
    },
    mounted() {
        this.commandeLoading = true
        this.loadCommande(this.commandeId).then((commande) => {
            this.commandeLoading = false
            this.commande = commande;
            this.initFileDrop();
        })
    }
};
